import React from "react";

/**
 * Consistent "AI is working" progress indicator used across NewDeck flows
 * (chunking script text, converting Q&A text, generating from topic, rechunking
 * a deck, etc.). One component, one look — users never see a bare "…" button.
 *
 * Props:
 *   title    — eyebrow label (e.g. "Chunking", "Converting", "Generating")
 *   message  — friendly explainer shown beneath the eyebrow
 *   testId   — optional data-testid override
 */
export default function AIProgressIndicator({ title = "Working", message, testId }) {
  return (
    <div
      className="mt-4 border rule bg-white p-4 flex items-center gap-4 fade-in"
      data-testid={testId || `ai-progress-${title.toLowerCase()}`}
      role="status"
      aria-live="polite"
    >
      <div className="wave shrink-0"><span/><span/><span/><span/><span/></div>
      <div className="flex-1">
        <div className="eyebrow mb-1">{title}</div>
        <p className="text-sm text-[color:var(--ink-muted)]">{message}</p>
        <div className="mt-2 progress-track" />
      </div>
    </div>
  );
}
